/**
 * Notification Redux Slice
 * Manages WhatsApp and Email notification state
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  success: null,
  serviceStatus: {
    whatsapp: { configured: false, status: 'unknown' },
  },
  patientNotifications: [],
  allNotifications: [],
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    pages: 0,
  },
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    // Service Status
    checkServiceStatusRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    checkServiceStatusSuccess: (state, action) => {
      state.loading = false;
      state.serviceStatus = action.payload;
    },
    checkServiceStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Send Portal Credentials
    sendPortalCredentialsRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.success = null;
    },
    sendPortalCredentialsSuccess: (state, action) => {
      state.loading = false;
      state.success = action.payload.message;
    },
    sendPortalCredentialsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Send Appointment Reminder
    sendAppointmentReminderRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.success = null;
    },
    sendAppointmentReminderSuccess: (state, action) => {
      state.loading = false;
      state.success = action.payload.message;
    },
    sendAppointmentReminderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Send Report Ready
    sendReportReadyRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.success = null;
    },
    sendReportReadySuccess: (state, action) => {
      state.loading = false;
      state.success = action.payload.message;
    },
    sendReportReadyFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Send Custom Notification
    sendCustomNotificationRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.success = null;
    },
    sendCustomNotificationSuccess: (state, action) => {
      state.loading = false;
      state.success = action.payload.message;
    },
    sendCustomNotificationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Get Patient Notifications
    getPatientNotificationsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPatientNotificationsSuccess: (state, action) => {
      state.loading = false;
      state.patientNotifications = action.payload.data;
      state.pagination = action.payload.pagination;
    },
    getPatientNotificationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Get All Notifications (Admin)
    getAllNotificationsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getAllNotificationsSuccess: (state, action) => {
      state.loading = false;
      state.allNotifications = action.payload.data;
      state.pagination = action.payload.pagination;
    },
    getAllNotificationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Clear messages
    clearNotificationMessages: (state) => {
      state.error = null;
      state.success = null;
    },
  },
});

export const {
  checkServiceStatusRequest,
  checkServiceStatusSuccess,
  checkServiceStatusFailure,
  sendPortalCredentialsRequest,
  sendPortalCredentialsSuccess,
  sendPortalCredentialsFailure,
  sendAppointmentReminderRequest,
  sendAppointmentReminderSuccess,
  sendAppointmentReminderFailure,
  sendReportReadyRequest,
  sendReportReadySuccess,
  sendReportReadyFailure,
  sendCustomNotificationRequest,
  sendCustomNotificationSuccess,
  sendCustomNotificationFailure,
  getPatientNotificationsRequest,
  getPatientNotificationsSuccess,
  getPatientNotificationsFailure,
  getAllNotificationsRequest,
  getAllNotificationsSuccess,
  getAllNotificationsFailure,
  clearNotificationMessages,
} = notificationSlice.actions;

export default notificationSlice.reducer;
